import { Component, OnInit, Input } from '@angular/core';
import { AttendanceService } from '../../attendance-record/attendance.service';
import { AttendanceStatusService } from '../attendance-status.service';
import * as moment from 'moment';

@Component({
  selector: 'app-timestamp-table',
  templateUrl: './timestamp-table.component.html',
  styleUrls: ['./timestamp-table.component.css']
})
export class TimestampTableComponent implements OnInit {
  isMobile: boolean;
  filoData: any;
  isloading: Boolean = false;

  constructor(
    private attendanceService: AttendanceService,
    private attendanceStatusService: AttendanceStatusService,
  ) { }

  ngOnInit() {
    this.isMobile = this.attendanceService.getIsMobile;
    this.getAttendancePerBranch();
  }

  getAttendancePerBranch(){
    this.isloading = true;
    this.attendanceStatusService.getAttendancePerBranch().subscribe(
      (data) => {
        this.filoData = data.data;
        this.isloading = false;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  formatTime(date, format) {
    if(format === 'time'){
      return moment(date).format('H:mm')
    } else if (format === 'date'){
      return moment(date).format("LL"); 
    }
  }

}
